<template>
	<div class="blocks block-card-inline">
		<BlockCardControl
			:available-events="availableEvents"
			:default-img="defaultImg"
			@on-switch-view-click="onSwitchView"
		/>

		<div class="block-card-wrapper">
			<component
				:is="currentEvent.component"
				:item="currentEvent"
				:default-img="defaultImg"
			/>
		</div>
	</div>
</template>
<script>

import BlockCardEvent from '@/components/cards/CardEvent/BlockCardEvent.vue';
import BlockCardCollection from '@/components/cards/CardEvent/BlockCardCollection.vue';
import BlockCardStudio from '@/components/cards/CardEvent/BlockCardStudio.vue';

export default {
	name: 'CardEventMain',
	components: {
		BlockCardEvent,
		BlockCardCollection,
		BlockCardStudio,
	},
	props: {
		event: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			switcherView: 1
		}
	},
	computed: {
		currentEvent() {
			return this.availableEvents[Object.keys(this.availableEvents)[this.switcherView - 1]];
		},
		availableEvents() {
			return {
				...{ event: { ...this.event, component: 'BlockCardEvent' } },
				...(this.event?.collection ? { collection: { ...this.event.collection, component: 'BlockCardCollection' } } : {}),
				...(this.event?.studio ? { studio: { ...this.event.studio, component: 'BlockCardStudio' } } : {}),
			}
		},
		defaultImg() {
			return this.availableEvents?.event?.image || this.availableEvents?.collection?.logo?.url || this.availableEvents?.studio?.logo?.url;
		},
	},
	methods: {
		onSwitchView() {
			this.switcherView = (this.switcherView % Object.keys(this.availableEvents).length) + 1;
		},
	}
};
</script>
<style lang="scss" scoped>
.block {
	padding: 4rem 0;
	border-bottom: .1rem solid $dark-2;
	display: flex;
	flex-direction: column;

	&-lg {
		padding-bottom: 10rem;
		display: flex;
		flex-direction: column;
		gap: 5.6rem;

		&--border {
			border-bottom: .1rem solid $dark-2;
		}

		@media (max-width: 767px) {
			padding-bottom: 5rem;
			gap: 2.4rem;
		}
	}

	&__headline {
		width: 100%;
		display: flex;
		justify-content: space-between;
		gap: 2.4rem;
		align-items: center;
		margin-bottom: 2.4rem;

		@media (max-width: 767px) {
			flex-wrap: wrap;
			gap: 1.2rem;
		}
	}

	&__icon {
		font-size: 2.4rem;
		height: 2.4rem;
		width: 2.4rem;
		min-width: 2.4rem;
		display: inline-flex;
		align-items: center;
		justify-content: center;
	}

	&__title {
		line-height: 2.4rem;
		display: flex;
		gap: 1.5rem;

		@media (max-width: 767px) {
			&:not(.w-auto) {
				width: 100%;
			}
		}
	}

	&__nav {
		display: flex;
		gap: 2.4rem;

		@media (max-width: 767px) {
			width: 100%;
			justify-content: space-between;
		}
	}


	&-slider {
		overflow: hidden;

		&__nav {
			display: flex;
			align-items: center;
			gap: 1.2rem;

			&-prev,
			&-next {
				cursor: pointer;

				&.swiper-button-disabled {
					opacity: .45;
				}
			}
		}

		&:not(.swiper-initialized) .swiper-slide {
			@media (min-width: 450px) {
				width: calc(50% - 1.2rem);
				margin-right: 24px;
			}

			@media (min-width: 768px) {
				width: calc(33.33% - 1.7rem);
				margin-right: 24px;
			}

			@media (min-width: 991px) {
				width: calc(25% - 1.9rem);
				margin-right: 24px;
			}
		}
	}

	&-item {
		display: flex;
		flex-direction: column;
		gap: 1.2rem;

		&__image {
			height: 13.8rem;
			border: .1rem solid rgba($white, .25);
		}

		&__body {
			display: flex;
			flex-direction: column;
			gap: .4rem;
		}
	}

	&-card {
		border: .1rem solid $dark-2;
		background-color: rgba($black, .62);
		box-sizing: border-box;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		flex-grow: 1;
		min-height: 36.5rem;

		.about {
			&__row {
				flex-direction: row;
				gap: 2rem;
			}

			@media (max-width: 1039px) {
				&__count-text {
					display: none;
				}
			}
		}

		&-wrapper {
			.block-card {
				display: none;

				&:first-child {
					display: flex;
				}
			}
		}

		&__image {
			overflow: hidden;
			border-bottom: .1rem solid $dark-2;
			border-top: .1rem solid $dark-2;
			position: relative;
			height: 18.8rem;
		}

		&__control {
			position: absolute;
			top: 1.6rem;
			right: 1.6rem;
			cursor: pointer;
			z-index: 1;

			&-img {
				width: 3.5rem;
				height: 3.5rem;
				box-sizing: border-box;
				border: .1rem solid $dark-2;
				background-color: $black;
				position: relative;

				&:last-child {
					background-color: $dark-4;
				}

				&:first-child {
					z-index: 2;
				}

				&:nth-child(2) {
					margin: -110% 0 0 10%;
					z-index: 1;
				}

				&:nth-child(3) {
					margin: -110% 0 0 20%;
				}

				&:nth-child(n + 4) {
					display: none;
				}
			}
		}

		&__body {
			flex-grow: 1;
			box-sizing: border-box;
			padding: 1.2rem 1.6rem 1.6rem;
			display: flex;
			flex-direction: column;
			gap: .6rem;
		}

		&__date {
			opacity: .45;
			margin-bottom: .2rem;
		}

		&__row {
			width: 100%;
			display: flex;
			gap: 2rem;
			justify-content: space-between;
			margin-bottom: 1rem;
		}

		&__badges,
		&__actions {
			display: inline-flex;
			gap: 1.2rem;
		}

		&__icon {
			width: 2.4rem;
			min-width: 2.4rem;
			height: 2.4rem;
			font-size: 2.4rem;
			display: inline-flex;
			align-items: center;
			justify-content: center;
		}

		.about__row {
			padding: .4rem 0;
		}

		&-inline {
			position: relative;
			width: calc(25% - 1.8rem);

			@media (max-width: 990px) {
				width: calc(33.33% - 1.6rem);
			}

			@media (max-width: 767px) {
				width: calc(50% - 1.2rem);
			}

			@media (max-width: 450px) {
				width: 100%;
			}
		}
	}

	&-grid {
		padding: 5.2rem 0 4rem;
		width: 100%;
		display: flex;
		gap: 2.4rem;
		flex-wrap: wrap;
		border-bottom: .1rem solid $dark-2;

		&-more {
			display: flex;
			justify-content: center;
			width: 100%;
		}
	}

	&__data {
		display: flex;
		flex-direction: column;
		gap: 4.2rem;
		overflow: hidden;
		height: 10rem;
		position: relative;

		&:before {
			content: '';
			width: 100%;
			height: 8rem;
			display: block;
			position: absolute;
			bottom: 0;
			left: 0;
			pointer-events: none;
			background: linear-gradient(180deg, rgba(24, 39, 55, 0) 0, rgba(24, 39, 55, .9) 90%);
		}

		&.open:before {
			display: none;
		}

		&-more {
			margin-top: 2.4rem;
			justify-content: center;
			display: flex;
		}

		p {
			font-size: 1.4rem;
			line-height: 1.4;

			@media (max-width: 767px) {
				font-size: 1.2rem;
			}
		}

		h3 {
			font-weight: $bold;
			font-size: 1.8rem;

			@media (max-width: 767px) {
				font-size: 1.6rem;
			}
		}
	}

	&__text {
		display: flex;
		flex-direction: column;
		gap: 2rem;
	}
}
</style>
